import { render, staticRenderFns } from "./BusinessRegistrationLogsDetails.vue?vue&type=template&id=3b0423bc&scoped=true&"
import script from "./BusinessRegistrationLogsDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistrationLogsDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistrationLogsDetails.vue?vue&type=style&index=0&id=3b0423bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0423bc",
  null
  
)

export default component.exports